/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'LeadsEnrichmentIntegration',

    components: {
        BaseInput,
        BaseSelect,
    },

    props: {
        availableIntegrations: {
            type: Array,
            default: () => [],
        },
        integrationConfig: {
            type: Object,
            default: () => ({}),
        },
        integrationIndex: {
            type: Number,
            required: true,
        },
        prospectFields: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            fieldOptions: [],
            innerValue: {},
            currentIntegration: {},
            integrationOptions: [],
        };
    },

    watch: {
        availableIntegrations: {
            deep: true,
            handler() {
                this.updateIntegrationOptions();
            }
        },
        value: {
            immediate: true,
            deep: true,
            handler(value) {
                this.currentIntegration = { key: value._id, label: value.name };
                this.innerValue = {
                    ...value,
                    fields_to_populate: value.fields_to_populate
                        .map(key => ({ key, label: this.prospectFields[key] || key })),
                };
                this.updateIntegrationOptions();
            },
        },
        integrationConfig: {
            immediate: true,
            deep: true,
            handler(value) {
                this.fieldOptions = [];
                const integrationKeys = value?.returned_keys || {};
                for (const [key, label] of Object.entries(this.prospectFields)) {
                    if (integrationKeys[key]) {
                        this.fieldOptions.push({ key, label });
                    }
                }
            }
        },
        innerValue: {
            deep: true,
            handler(value) {
                this.$emit('change', {
                    ...value,
                    fields_to_populate: (value.fields_to_populate || []).map(d => d.key),
                });
            }
        }
    },

    methods: {
        updateIntegrationOptions() {
            this.integrationOptions = [{ key: this.value._id, label: this.value.name }];
            for (const { _id, name } of this.availableIntegrations) {
                this.integrationOptions.push({ key: _id, label: name });
            }
        },

        onIdChange(e) {
            if (e.key) {
                this.$emit('id-change', {
                    from: { _id: this.value._id, name: this.value.name },
                    to: { _id: e.key, name: e.label },
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads-enrichment-integration"},[_c('h4',[_c('span',[_vm._v(_vm._s(("#" + (_vm.integrationIndex + 1)))+" "+_vm._s(_vm.$t('leads.settings.integration')))]),_c('a',{staticClass:"btn btn-mini has-action",attrs:{"href":"#"},on:{"click":function($event){return _vm.$emit('delete', _vm.value._id)}}},[_vm._v(_vm._s(_vm.$t('leads.settings.delete_integration')))])]),_c('validation-provider',{attrs:{"slim":true,"name":"intergration_name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"intergration_name","label":_vm.$t('leads.settings.integration_name'),"options":_vm.integrationOptions},on:{"input":_vm.onIdChange},model:{value:(_vm.currentIntegration),callback:function ($$v) {_vm.currentIntegration=$$v},expression:"currentIntegration"}})]}}])}),_c('validation-provider',{attrs:{"slim":true,"name":"url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"type":"url","name":"url","label":_vm.$t('leads.settings.integration_url'),"required":true},model:{value:(_vm.innerValue.url),callback:function ($$v) {_vm.$set(_vm.innerValue, "url", $$v)},expression:"innerValue.url"}})]}}])}),_c('validation-provider',{attrs:{"slim":true,"name":"secret_key"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"name":"secret_key","label":_vm.$t('leads.settings.integration_secret_key'),"required":true},model:{value:(_vm.innerValue.secret_key),callback:function ($$v) {_vm.$set(_vm.innerValue, "secret_key", $$v)},expression:"innerValue.secret_key"}})]}}])}),_c('validation-provider',{attrs:{"slim":true,"name":"fields_to_populate"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"fields_to_populate","label":_vm.$t('leads.settings.integration_fields_to_populate'),"track-by":"key","taggable":true,"hide-selected":true,"hint-after-label":true,"multiple":true,"options":_vm.fieldOptions},model:{value:(_vm.innerValue.fields_to_populate),callback:function ($$v) {_vm.$set(_vm.innerValue, "fields_to_populate", $$v)},expression:"innerValue.fields_to_populate"}})]}}])}),_c('hr')],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LeadsEnrichmentIntegration.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__